import React from 'react';
import styled from 'styled-components';

const BaseStyledDiv = styled.div`
  width: 100%;
  overflow: auto;
`;

const MainStyledDiv = styled.div`
  padding-bottom: 24px;
  ${(props: { isWide: boolean }) =>
    props.isWide
      ? `float: left;
      margin-left: 2%;
      width: 78%;`
      : `border-collapse: separate;
      border-radius: 16px;
      margin-right: 7%;`}
`;

const ImageStyledDiv = styled.div`
  position: relative;
  float: left;
  border-radius: 30%;
  width: ${(props: { isWide: boolean; isBotIcon: boolean }) =>
    props.isWide ? 48 : 32}px;
  height: ${(props: { isWide: boolean; isBotIcon: boolean }) =>
    props.isWide ? 48 : 32}px;
  justify-content: center;
  align-items: center;
  display: flex;
  overflow: hidden;

  img {
    width: ${(props: { isWide: boolean; isBotIcon: boolean }) =>
      props.isWide ? (props.isBotIcon ? 32 : 40) : props.isBotIcon ? 24 : 26}px;
  }
`;

const MessageStyledDiv = styled.div`
  background-color: #fff;
  border-radius: 13px;
  font-size: 14px;
  margin-left: ${(props: { isWide: boolean }) => (props.isWide ? 16 : 36)}px;
  ${(props: { isWide: boolean }) =>
    props.isWide
      ? `float: left;
      padding-bottom: 2%;
      padding-top: 3%;
      width: 78%;
      word-break: break-all;`
      : ``}
`;

interface Props {
  children: any;
  isWide: boolean;
  image?: string;
  hasBotIcon?: boolean;
  style?: object;
  lastMessageDivRef?: React.RefObject<HTMLDivElement>;
}

export const ChatLeft = (props: Props) => {
  const { children, isWide, image, hasBotIcon, style } = props;

  return (
    <BaseStyledDiv>
      <MainStyledDiv isWide={isWide}>
        <ImageStyledDiv isWide={isWide} isBotIcon={hasBotIcon!}>
          <img src={image} alt="" />
        </ImageStyledDiv>
        <MessageStyledDiv isWide={isWide} style={{ ...style }}>
          {children}
        </MessageStyledDiv>
      </MainStyledDiv>
    </BaseStyledDiv>
  );
};
